import { Link } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { ArrowLeft, FileText } from 'lucide-react';
import Footer from '../components/Footer';

export default function TermsOfServicePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-violet-950/30 to-slate-950 py-8 px-4">
      <div className="max-w-3xl mx-auto">
        {/* Back button */}
        <Link to="/">
          <Button variant="ghost" className="mb-6 text-foreground/70 hover:text-foreground">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Grįžti į pradžią
          </Button>
        </Link>

        <Card className="bg-slate-900/50 border-primary/20 p-6 sm:p-8">
          {/* Header */}
          <div className="text-center mb-8">
            <FileText className="w-12 h-12 text-primary mx-auto mb-4" />
            <h1 className="text-3xl font-display font-bold text-foreground mb-2">
              Naudojimosi sąlygos
            </h1>
            <p className="text-lg text-primary">NUMENAXIS – savęs pažinimo erdvė</p>
            <p className="text-sm text-muted-foreground mt-2">
              Paskutinį kartą atnaujinta: 2026-01-17
            </p>
          </div>

          {/* Introduction */}
          <div className="prose prose-invert max-w-none">
            <p className="text-foreground/90 leading-relaxed mb-4">
              Sveiki atvykę į NUMENAXIS.
            </p>
            <p className="text-foreground/90 leading-relaxed mb-6">
              NUMENAXIS – tai savęs pažinimo ir refleksijos platforma, pateikianti numerologinę ir energetinę informaciją, skirtą savistabai, sąmoningam planavimui ir asmeniniam augimui.
            </p>
            <p className="text-foreground/90 leading-relaxed mb-6">
              Naudodamiesi šia platforma, jūs sutinkate su žemiau pateiktomis sąlygomis.
            </p>

            {/* Section 1 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-primary mb-4">1. Bendrosios nuostatos</h2>
              <p className="text-foreground/80 mb-2">
                <strong>1.1.</strong> Visa NUMENAXIS pateikiama informacija yra edukacinio ir informacinio pobūdžio.
              </p>
              <p className="text-foreground/80 mb-2">
                <strong>1.2.</strong> Platformoje pateikiami skaičiavimai, interpretacijos ir tekstai nėra medicininės, psichologinės, teisinės ar finansinės konsultacijos.
              </p>
              <p className="text-foreground/80 mb-2">
                <strong>1.3.</strong> NUMENAXIS nesuteikia prognozių, garantijų ar pažadų dėl konkrečių gyvenimo įvykių ar rezultatų.
              </p>
              <p className="text-foreground/80">
                <strong>1.4.</strong> Vartotojas pats atsako už tai, kaip interpretuoja ir taiko platformoje pateiktą informaciją.
              </p>
            </section>

            {/* Section 2 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-primary mb-4">2. Asmeniniai skaičiavimai ir bendras turinys</h2>
              <p className="text-foreground/80 mb-2">
                <strong>2.1.</strong> Platformoje pateikiami du informacijos tipai:
              </p>
              <ul className="list-disc list-inside text-foreground/80 space-y-1 ml-4 mb-3">
                <li>asmeniniai skaičiavimai (paremti vartotojo įvestais duomenimis),</li>
                <li>bendras informacinis turinys, įskaitant „Dienos energijos analizę".</li>
              </ul>
              <p className="text-foreground/80 mb-2">
                <strong>2.2.</strong> „Dienos energijos analizė" yra bendro pobūdžio informacija apie kalendorinę dieną ir nėra suasmeninta.
              </p>
              <p className="text-foreground/80">
                <strong>2.3.</strong> Asmeniniai skaičiavimai ir bendras turinys yra aiškiai atskirti tiek logikoje, tiek pateikime.
              </p>
            </section>

            {/* Section 3 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-primary mb-4">3. Interpretacijų pobūdis</h2>
              <p className="text-foreground/80 mb-2">
                <strong>3.1.</strong> NUMENAXIS naudojami metodai gali apimti numerologines, simbolines ir energetines interpretacijas.
              </p>
              <p className="text-foreground/80 mb-2">
                <strong>3.2.</strong> Šios interpretacijos yra simbolinės ir skirtos savistabai, o ne faktiniam ateities numatymui.
              </p>
              <p className="text-foreground/80">
                <strong>3.3.</strong> Pateikiama informacija atspindi bendras tendencijas, o ne individualią realybę.
              </p>
            </section>

            {/* Section 4 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-primary mb-4">4. Mokamas turinys ir skaitmeniniai produktai</h2>
              <p className="text-foreground/80 mb-2">
                <strong>4.1.</strong> Kai kurios funkcijos gali būti prieinamos tik įsigijus mokamą prieigą (pvz., VIP planus ar skaitmeninius produktus).
              </p>
              <p className="text-foreground/80 mb-2">
                <strong>4.2.</strong> Mokamas turinys laikomas suteiktu nuo momento, kai jis tampa prieinamas vartotojui.
              </p>
              <p className="text-foreground/80">
                <strong>4.3.</strong> Skaitmeninis turinys yra intelektinė nuosavybė ir negali būti naudojamas komerciniais tikslais be leidimo.
              </p>
            </section>

            {/* Section 5 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-primary mb-4">5. Atsakomybės ribojimas</h2>
              <p className="text-foreground/80 mb-2">
                <strong>5.1.</strong> NUMENAXIS neatsako už vartotojo sprendimus ar pasekmes, kilusias naudojantis platformoje pateikta informacija.
              </p>
              <p className="text-foreground/80 mb-2">
                <strong>5.2.</strong> Platforma nepakeičia profesionalios specialistų pagalbos.
              </p>
              <p className="text-foreground/80">
                <strong>5.3.</strong> Esant emociniams ar psichologiniams sunkumams, rekomenduojama kreiptis į kvalifikuotus specialistus.
              </p>
            </section>

            {/* Section 6 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-primary mb-4">6. Pakeitimai</h2>
              <p className="text-foreground/80">
                NUMENAXIS pasilieka teisę bet kada atnaujinti šias naudojimosi sąlygas. Atnaujinta versija įsigalioja nuo jos paskelbimo.
              </p>
            </section>

            {/* Section 7 */}
            <section className="mb-8">
              <h2 className="text-xl font-semibold text-primary mb-4">7. Baigiamosios nuostatos</h2>
              <p className="text-foreground/80 mb-3">
                Naudodamiesi NUMENAXIS, jūs patvirtinate, kad suprantate šių sąlygų pobūdį ir naudojatės platforma sąmoningai.
              </p>
              <p className="text-foreground/80">
                NUMENAXIS sukurta kaip erdvė tyrinėjimui, ne kaip nurodymų sistema.
              </p>
            </section>
          </div>

        </Card>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
}
